import React from "react";
import { Dialog, DialogTitle, DialogContent, IconButton, Box, Typography, Paper, CircularProgress } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { fetchUserMessages } from "../services/api";

export default function UserMessagesModal({ open, user, token, onClose }) {
  const [messages, setMessages] = React.useState([]);
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    if (!open || !user) return;
    setLoading(true);
    fetchUserMessages(user.id, token)
      .then(setMessages)
      .finally(() => setLoading(false));
  }, [open, user, token]);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>
        Μηνύματα χρήστη #{user?.id}
        <IconButton onClick={onClose} sx={{ position: "absolute", right: 8, top: 8 }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        {loading ? (
          <Box sx={{ textAlign: "center", py: 4 }}>
            <CircularProgress />
          </Box>
        ) : (
          <Box sx={{ mt: 2, maxHeight: 450, overflowY: "auto" }}>
            {messages.length === 0 ? (
              <Typography color="text.secondary" align="center">Δεν βρέθηκαν μηνύματα.</Typography>
            ) : messages.map((msg) => (
              <Box key={msg.id} sx={{ mb: 1.5, textAlign: msg.sender === "user" ? "left" : "right" }}>
                <Paper elevation={msg.sender === "user" ? 1 : 2}
                  sx={{
                    display: "inline-block",
                    p: 1.2, px: 2,
                    bgcolor: msg.sender === "user" ? "#fff" : "#e0f7fa"
                  }}>
                  <Typography variant="body2" fontWeight={msg.sender === "bot" ? 600 : 400}>
                    <span style={{ color: "#888", fontSize: "0.8em" }}>{msg.sender}</span>: {msg.text}
                  </Typography>
                  <Typography variant="caption" sx={{ color: "#90a4ae" }}>
                    {msg.timestamp}
                  </Typography>
                </Paper>
              </Box>
            ))}
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
}
